require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./basic-styles-sandbox-form-sandbox.json") })
        }
      }, "path---basic-styles-sandbox-form-sandbox");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---basic-styles-sandbox-form-sandbox!./.cache/json/basic-styles-sandbox-form-sandbox.json
// module id = 1982
// module chunks = 231608221292675